(() => {
  if (window.apexExperienceReady) return;
  window.apexExperienceReady = true;
  const init = () => {
    document.querySelectorAll('[data-apex-pack]').forEach(link => {
      if (link.dataset.apexBound) return;
      link.dataset.apexBound = 'true';
      link.addEventListener('click', () => {
        const range = link.closest('.apex-range');
        const card = document.getElementById(link.dataset.apexPack);
        if (!range || !card) return;
        range.querySelectorAll('[data-apex-pack]').forEach(option => option.removeAttribute('aria-current'));
        range.querySelectorAll('.apex-product').forEach(product => product.classList.remove('apex-pack-selected'));
        link.setAttribute('aria-current', 'true');
        card.classList.add('apex-pack-selected');
      });
    });
    const hero = document.querySelector('.apex-hero');
    const range = document.querySelector('.apex-range');
    const quickChoice = document.querySelector('[data-apex-quick-choice]');
    if (!('IntersectionObserver' in window)) return;
    if (hero && range && quickChoice && !quickChoice.dataset.apexBound) {
      quickChoice.dataset.apexBound = 'true';
      let heroVisible = true;
      let rangeVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          if (entry.target === range) rangeVisible = entry.isIntersecting;
        });
        quickChoice.hidden = heroVisible || rangeVisible;
      }, {threshold:0});
      observer.observe(hero);
      observer.observe(range);
    }
    document.querySelectorAll('.apex-section').forEach(section => {
      if (section.dataset.apexRevealBound) return;
      section.dataset.apexRevealBound = 'true';
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          section.classList.add('apex-in-view');
          observer.disconnect();
        }
      }, {threshold:0.1});
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


// Optional memory cards are added only after an explicit checkbox action.
// Delegation survives native section rendering. A full cart reload confirms totals.
if (!window.apexMemoryBound) {
  window.apexMemoryBound = true;
  document.addEventListener('change', async (event) => {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement) || !checkbox.matches('[data-apex-memory]')) return;
    const form = checkbox.closest('form');
    const page = checkbox.closest('.apex-cart-page');
    const status = form?.querySelector('[data-memory-status]');
    if (!form || !page || !status || form.getAttribute('aria-busy') === 'true') return;
    const intended = checkbox.checked;
    const locked = Array.from(page.querySelectorAll('button,input:not([type="hidden"]),select')).filter(control => !control.disabled);
    locked.forEach(control => { control.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    status.textContent = status.dataset.busy;
    const timeout = new AbortController();
    const timer = setTimeout(() => timeout.abort(), 20000);
    try {
      let response;
      if (intended) {
        const fields = new FormData(form);
        response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal: timeout.signal,
          body: JSON.stringify({items: [{id: Number(fields.get('id')), quantity: Number(fields.get('quantity')), properties: {_apex_memory_option: 'yes'}}]})
        });
      } else {
        const keys = JSON.parse(form.querySelector('[data-memory-keys]').textContent);
        response = await fetch(Theme.routes.cart_update_url + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal: timeout.signal,
          body: JSON.stringify({updates: Object.fromEntries(keys.map(key => [key, 0]))})
        });
      }
      const result = await response.json();
      if (!response.ok || result.errors || result.status >= 400) throw new Error('Cart update failed');
      window.location.assign(Theme.routes.cart_url);
    } catch (error) {
      checkbox.checked = !intended;
      status.textContent = status.dataset.error;
      form.removeAttribute('aria-busy');
      locked.forEach(control => { control.disabled = false; });
    } finally {
      clearTimeout(timer);
    }
  });
}
